import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationEmailSubscription from "../useTranslationEmailSubscription.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import ActionButton from "../../common/widgets/ActionButton.js";
import useMutationEmailSubscriptionUpdate from "../mutate/useMutationEmailSubscriptionUpdate.js";
import useServerErrorFormatter from "../../common/modals/useServerErrorFormatter.js";
import useErrorModal from "../../common/modals/useErrorModal.js";
import useQueryEmailSubscriptionByEmail from "./useQueryEmailSubscriptionByEmail.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import "./SpotterUnsubscriptionBlock.scss";

function SpotterUnsubscriptionBlock(props) {
  const { email } = props;
  const {
    data: emailSubscriptionData,
    loading: emailSubscriptionLoading,
    errors: emailSubscriptionErrors,
  } = useQueryEmailSubscriptionByEmail(email);

  const { t, loading: tLoading } = useTranslationEmailSubscription();
  useShowLoader(tLoading, "SpotterUnsubscriptionBlock");

  const { mutate, loading, errors } = useMutationEmailSubscriptionUpdate();
  const errorMsg = useServerErrorFormatter(errors);
  const { ErrorModal, show: showErrorModal } = useErrorModal(
    <>
      <p>{t("email-subscription:email_subscription_error_message")}</p>
      {errorMsg}
    </>
  );

  const updateSubscription = (canReceiveAlert) => {
    const variables = {};
    variables["email"] = email;
    variables["canReceiveAlert"] = canReceiveAlert;
    mutate({ variables }).catch(() => {
      showErrorModal();
    });
  };

  return (
    <>
      {ErrorModal}
      <WaitForData
        loading={emailSubscriptionLoading}
        errors={emailSubscriptionErrors}
        onLoaded={() => (
          <div className="SpotterUnsubscriptionBlock">
            <Row>
              <Col>
                <h1>
                  {t("email-subscription:email_unsubscription_spotter_title")}
                </h1>
              </Col>
            </Row>
            {(!emailSubscriptionData ||
              emailSubscriptionData.canReceiveAlert) && (
              <>
                <Row>
                  <Col>
                    {t("email-subscription:email_unsubscription_spotter_text")}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ActionButton
                      onClick={() => updateSubscription(false)}
                      loading={loading}
                    >
                      {t(
                        "email-subscription:email_unsubscription_button_label"
                      )}
                    </ActionButton>
                  </Col>
                </Row>
              </>
            )}
            {emailSubscriptionData && !emailSubscriptionData.canReceiveAlert && (
              <>
                <Row>
                  <Col>
                    {t("email-subscription:email_subscription_spotter_text")}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ActionButton
                      onClick={() => updateSubscription(true)}
                      loading={loading}
                    >
                      {t("email-subscription:email_subscription_button_label")}
                    </ActionButton>
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}
      />
    </>
  );
}

export default SpotterUnsubscriptionBlock;
